import { render, staticRenderFns } from "./SupportMetrics.vue?vue&type=template&id=474282af&scoped=true&lang=pug"
import script from "./SupportMetrics.vue?vue&type=script&lang=js"
export * from "./SupportMetrics.vue?vue&type=script&lang=js"
import style0 from "./SupportMetrics.vue?vue&type=style&index=0&id=474282af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474282af",
  null
  
)

export default component.exports